/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner } from './get-zeus-organization-identity-verifications-for-president200-response-inner-antisocial-forces-check-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner } from './get-zeus-organization-identity-verifications-for-president200-response-inner-beneficial-owners-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner } from './get-zeus-organization-identity-verifications-for-president200-response-inner-identity-verification-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerSnailMailVerificationInner } from './get-zeus-organization-identity-verifications-for-president200-response-inner-snail-mail-verification-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistory } from './get-zeus-organization-identity-verifications-for-president200-response-inner-status-history';

/**
 * 取引時確認詳細情報 
 * @export
 * @interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
 */
export interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner {
    /**
     * 取引時確認ID
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'id': string;
    /**
     * 法人名
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'organizationName': string;
    /**
     * 法人番号
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'corporateNumber': string;
    /**
     * 法人種別
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'corporateType'?: GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerCorporateTypeEnum;
    /**
     * 代表者氏名
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'representativeName': string;
    /**
     * 本社所在地：住所
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'address': string;
    /**
     * 本社所在地：郵便番号
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'postalCode': string;
    /**
     * 電話番号
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'phoneNumber': string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'email': string;
    /**
     * 作成日時
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'createdAt': string;
    /**
     * メモ
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'note'?: string;
    /**
     * 利用目的
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'purposeTransaction': GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerPurposeTransactionEnum;
    /**
     * 利用目的その他
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'purposeTransactionOther'?: string;
    /**
     * 反社チェック一覧
     * @type {Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner>}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'antisocialForcesCheck': Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner>;
    /**
     * 実質的支配者一覧
     * @type {Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner>}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'beneficialOwners': Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner>;
    /**
     * マイナンバーで確認済の認証情報一式
     * @type {Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner>}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'identityVerification': Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner>;
    /**
     * 郵送確認一覧
     * @type {Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerSnailMailVerificationInner>}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'snailMailVerification': Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerSnailMailVerificationInner>;
    /**
     * 
     * @type {GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistory}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'statusHistory'?: GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistory;
}

export const GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerCorporateTypeEnum = {
    exceptMajorityCapitalVoteCorporate: 'EXCEPT_MAJORITY_CAPITAL_VOTE_CORPORATE',
    majorityCapitalVoteCorporate: 'MAJORITY_CAPITAL_VOTE_CORPORATE'
} as const;

export type GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerCorporateTypeEnum = typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerCorporateTypeEnum[keyof typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerCorporateTypeEnum];
export const GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerPurposeTransactionEnum = {
    adExpenses: 'AD_EXPENSES',
    calculatedAsExpense: 'CALCULATED_AS_EXPENSE',
    other: 'OTHER',
    stocking: 'STOCKING',
    systemUsageFee: 'SYSTEM_USAGE_FEE'
} as const;

export type GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerPurposeTransactionEnum = typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerPurposeTransactionEnum[keyof typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerPurposeTransactionEnum];


